export const BUDGET_PROGRESS_DESTINATION = '/user/topic/budgetprogress';
export const QBO_ACCOUNT_SETUP_PROGESS_DESTINATION = '/user/topic/accountsetupprogress';
export const REVIEW_DATA_CALCULATE_DESTINATION = '/user/topic/validatedataprogress';